import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async createRolePermissionDistribution(data) {
    let response = await apiCall("rolepermission/create", data);
    return response;
  },
  async fetchRolePermissionsDetailed(data) {
    let response = await apiCall("rolepermission/list/detailed", data);
    return response;
  },
  async createPermissionDistribution(data) {
    let response = await apiCall("distribution/create", data);
    return response;
  },
};
